// Tree-shaken ECharts registration.
// Import { echarts } from here rather than from "echarts" directly so all
// chart types and components are registered exactly once at module load.
// Add new chart/component imports here as the reporting surface grows.

import * as echarts from "echarts/core";
import { LineChart, BarChart } from "echarts/charts";
import {
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  DatasetComponent,
  TransformComponent,
  GraphicComponent
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([
  LineChart,
  BarChart,
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  DatasetComponent,
  TransformComponent,
  GraphicComponent,
  CanvasRenderer
]);

// Shared "atlas" theme — pins chart text to Inter so server-side renders
// (for the reactive-viz AI agent's vision tool) match the browser exactly.
// Keep this in sync with `atlas-hub/services/hub/src/ai/chartRenderer.ts`.
export const ATLAS_CHART_THEME_NAME = "atlas";
echarts.registerTheme(ATLAS_CHART_THEME_NAME, {
  textStyle: {
    fontFamily: "Inter, sans-serif"
  }
});

export { echarts };
